@if (isLoading) {
  <div class="loading-shade">
    @if (isLoading) {
      <mat-spinner diameter="64"></mat-spinner>
    }
  </div>
}
